import { render, staticRenderFns } from "./store.vue?vue&type=template&id=234c684a&scoped=true"
import script from "./store.vue?vue&type=script&lang=js"
export * from "./store.vue?vue&type=script&lang=js"
import style0 from "./store.vue?vue&type=style&index=0&id=234c684a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c684a",
  null
  
)

export default component.exports